import { Location, Outlet, useLocation, useNavigate } from "react-router-dom";

import ArrowBack from "@mui/icons-material/ArrowBack";
import Typography from "@mui/material/Typography";

import ActionBar from "@app/analytics/components/ActionBar";
import ActionBarButton from "@app/analytics/components/ActionBar/ActionBarButton";
import { useAuthenticated } from "@app/common/auth/useAuth";
import ROUTES from "@app/common/routes";
import { isWorkspaceAdmin } from "@app/common/workspaces/workspaceUtils";

import Stack, { Row } from "@rui/Stack";
import { StickyContainer } from "@rui/styles";

const getSettingsTitle = (location: Location, isWorkspaceAdmin: boolean) => {
  if (location.pathname.includes(ROUTES.NEW_WORKSPACE)) {
    return "Create Workspace";
  }

  if (
    location.pathname.includes(ROUTES.JOIN_WORKSPACE) ||
    location.pathname.includes(ROUTES.INVITATION_WORKSPACE)
  ) {
    return "Join Workspace";
  }

  if (location.pathname.includes(ROUTES.WORKSPACE_SETTINGS_ROOT)) {
    return isWorkspaceAdmin ? "Manage Workspace" : "Workspace Settings";
  }

  if (location.pathname.includes(ROUTES.BILLING)) {
    return "Plan & Billing";
  }

  return "Account Settings";
};

const AccountSettings = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { user } = useAuthenticated();

  const settingsTitle = getSettingsTitle(
    location,
    isWorkspaceAdmin(user.workspace)
  );

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Stack sx={{ height: "100%" }}>
      <StickyContainer>
        <ActionBar>
          <Row variant="left" sx={{ width: "100%" }}>
            <Row variant="left" flexGrow={1} sx={{ mr: { xxs: 3, md: 1 } }}>
              <ActionBarButton onClick={handleBack}>
                <ArrowBack />
              </ActionBarButton>
              <Typography
                variant="h2"
                sx={{ color: "shades.neutral.700", ml: "10px" }}
              >
                {settingsTitle}
              </Typography>
            </Row>
          </Row>
        </ActionBar>
      </StickyContainer>
      <Stack sx={{ width: "100%", height: "100%" }}>
        <Outlet />
      </Stack>
    </Stack>
  );
};

export default AccountSettings;
